import * as Common from '../../commons/common';

export class SheetBase {
  grade: string = ""
  name: string = ""
  curriculum_id: string = ""
  subject_name: string = ""
  exec_date: string = ""
  grade_cache: string = ""
  created_by: string = null
  browse_lock: boolean = false
  edit_lock: boolean = false
  is_sort_answer_image_enable: boolean = false
  is_print_view_point: boolean = false
  is_print_part1: boolean = false
  is_disp_correct_question_image: boolean = false
  api_type: number = Common.ApiTypeEnum.Classroom
}

export class SheetGroup {
  sheet_id: number | null = null
  sheet_id_cache: number | null = null
  room_name: string = ""
  course_id: string = ""
  course_id_cache: string = ""
  course_name: string = ""
  is_course_exist: boolean = true
  is_uploaded: boolean = false
  students: Student[] = new Array<Student>()
}

export class Student {
  sheet_id: number | null = null
  course_id: string = ""
  api_student_id: string = ""
  examinee_id: number | null = null
  student_no: number = 0
  student_no_cache: number = 0
  student_no_character: string = ""
  student_name: string = ""
  is_uploaded: boolean = false
}

export class Condition{
  grade: string = ""
  month: string = ""
  sheet_group_key: string = ""
  curriculum_id: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
  is_digital_paper: boolean = false
}

export class Sheet {
  grade: string
  name: string
  curriculum_id: string
  subject_name: string
  exec_date: string
  edit_lock: boolean
  browse_lock: boolean
  is_sort_answer_image_enable: boolean
  is_print_view_point: boolean
  is_print_part1: boolean
  digital_answer_type: number
  sheet_group_key: number
  is_disp_correct_question_image: boolean

  constructor(x: any){
    this.grade = x.grade;
    this.name = x.name;
    this.curriculum_id = x.curriculum_id;
    this.subject_name = x.subject_name;
    this.exec_date = x.exec_date;
    this.edit_lock = x.edit_lock;
    this.browse_lock = x.browse_lock;
    this.is_sort_answer_image_enable = x.is_sort_answer_image_enable
    this.is_print_view_point = x.is_print_view_point;
    this.is_print_part1 = x.is_print_part1;
    this.sheet_group_key = x.sheet_group_key;
    this.is_disp_correct_question_image = x.is_disp_correct_question_image;
  }
}